export default __webpack_public_path__ + "static/slowni-4cf130a550c2c1fb06d0f4f409019dbd.png";